import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { DatePipe, DecimalPipe, formatNumber } from "@angular/common";

import * as moment from "moment";

import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { loadedTenantState } from "src/app/store/reducers";

import {
  FieldType,
  FormatType,
} from "src/app/models/custom-table/custom-table.model";

@Pipe({
  name: "gridPipe",
})
export class GridPipe implements PipeTransform, OnDestroy {
  tenantSub: Subscription;
  tenant$: Observable<any>;
  formatter: any;

  // locale: string = localStorage.getItem("locale");
  locale: string = 'en-en';

  constructor(
    private store: Store,
    private decimalPipe: DecimalPipe,
    private datePipe: DatePipe
  ) {
    this.tenant$ = this.store.pipe(select(loadedTenantState));
  }

  ngOnDestroy(): void {
    if (this.tenantSub) {
      this.tenantSub.unsubscribe();
    }
  }

  transform(value: any, params: any, params2?: any): any {
    let formattedSubject = new BehaviorSubject<string>("");
    this.tenantSub = this.tenant$.subscribe((data: any) => {
      if (data !== null && data !== undefined) {
        this.formatter = this.customFormatter(value, data, params, params2);
        formattedSubject.next(this.formatter);
      }
    });
    return formattedSubject;
  }

  customFormatter(value: any, formatter: any, columnConfig: any, columnElement: any): any {
    //TODO: add model to formatter and columnConfig

    if (value !== null && value !== undefined) {
      //Date Fields
      if (
        (columnConfig?.fieldType === FieldType.DATE ||
          columnConfig?.fieldType === FieldType.DATE_TIME) &&
        columnConfig?.formatType === FormatType.DATE
      ) {
        return moment(value).format(`${formatter?.dateFormat}`).toString();
      }
      if (
        columnConfig?.fieldType === FieldType.DATE_TIME &&
        columnConfig?.formatType === FormatType.TIME
      ) {
        return moment(value).format(`${formatter?.timeFormat}`).toString();
      }
      if (
        (columnConfig?.fieldType === FieldType.DATE ||
          columnConfig?.fieldType === FieldType.DATE_TIME) &&
        columnConfig?.formatType === FormatType.DATETIME
      ) {
        return moment(value).format(`${formatter?.datetimeFormat}`).toString();
      }
      if (columnConfig?.fieldType === FieldType.DATE && Date.parse(value)) {
        return this.datePipe.transform(value);
      }

      //Numeric Fields
      if (
        (columnConfig?.fieldType === FieldType.NUMBER ||
          columnConfig?.fieldType === FieldType.CHIP_NUMBER) &&
        columnConfig?.formatType === FormatType.UNITPRICE
      ) {
        return formatNumber(
          value,
          this.locale,
          `${formatter?.unitPriceDecimalPlaces ? '1.' + formatter?.unitPriceDecimalPlaces + '-' + formatter?.unitPriceDecimalPlaces : '1.2-2'}`
        );
      }
      if (
        (columnConfig?.fieldType === FieldType.NUMBER ||
          columnConfig?.fieldType === FieldType.CHIP_NUMBER) &&
        columnConfig?.formatType === FormatType.UOM
      ) {
        return formatNumber(
          value, 
          this.locale, 
          `${formatter?.uomDecimalPlaces ? '1.' + formatter?.uomDecimalPlaces + '-' + formatter?.uomDecimalPlaces : '1.2-2'}`
        );
      }
      if (
        (columnConfig?.fieldType === FieldType.NUMBER ||
          columnConfig?.fieldType === FieldType.CHIP_NUMBER) &&
        columnConfig?.formatType === FormatType.FUELUOM
      ) {
        return formatNumber(
          value, 
          this.locale, 
          `${formatter?.forecourtUomDecimalPlaces ? '1.' + formatter?.forecourtUomDecimalPlaces + '-' + formatter?.forecourtUomDecimalPlaces : '1.2-2'}`
        );
      }
      if (
        (columnConfig?.fieldType === FieldType.NUMBER ||
          columnConfig?.fieldType === FieldType.CHIP_NUMBER) &&
        columnConfig?.formatType === FormatType.FUELUNITPRICE
      ) {
        return formatNumber(
          value,
          this.locale,
          `${formatter?.forecourtUnitPriceDecimalPlaces ? '1.' + formatter?.forecourtUnitPriceDecimalPlaces + '-' + formatter?.forecourtUnitPriceDecimalPlaces : '1.3-3'}`
        );
      }
      if (
        (columnConfig?.fieldType === FieldType.NUMBER ||
          columnConfig?.fieldType === FieldType.CHIP_NUMBER) &&
        columnConfig?.formatType === FormatType.AMOUNT
      ) {
        //Special case for products table (product can be fuel or not)
        if (this.checkFuelProduct(columnElement) && columnConfig.fuelFormatType) {
          return formatNumber(
            value, 
            this.locale, 
            `${formatter?.forecourtUnitPriceDecimalPlaces ? '1.' + formatter?.forecourtUnitPriceDecimalPlaces + '-' + formatter?.forecourtUnitPriceDecimalPlaces : '1.3-3'}`
          );
        }
        return formatNumber(
          value, 
          this.locale, 
          `${formatter?.amountDecimalPlaces ? '1.' + formatter?.amountDecimalPlaces + '-' + formatter?.amountDecimalPlaces : '1.2-2'}`
        );
      }
      if (
        (columnConfig?.fieldType === FieldType.NUMBER ||
          columnConfig?.fieldType === FieldType.CHIP_NUMBER) &&
        !isNaN(value)
      ) {
        return value;
      }

      //Text fields
      if (
        columnConfig?.fieldType === FieldType.STRING ||
        columnConfig?.fieldType === FieldType.CHIP_STRING
      ) {
        return value;
      }
    }
  }

  checkFuelProduct(columnElement: any) {
    return columnElement.isFuel;
  }
}
